<template>
  <div
    id="scrolldata"
    v-loading="isloading"
    class="card_mian"
    :class="
      carddata != null
        ? carddata.length > 0
          ? ''
          : 'card_content_backimage'
        : ''
    "
  >
    <el-row
      :gutter="0"
      :style="{height: '100%'}"
    >
      <slot />
      <div class="list">
        <Virtual_list
          data-key="VDeviceId"
          :list="carddata"
          :cell="cardtwoSmallVirtual"
          :is-horizontal="true"
          :extra-props="extraProps"
          :wrap-width="wrapWidth || 180"
          :wrap-height="wrapHeight"
          :keeps="6"
          @functionScoketsync_info_event="functionScoketsync_info_event"
        />
      </div>
    </el-row>

    <template v-if="dialogGroup">
      <el-dialog
        :modal-append-to-body="false"
        :visible.sync="dialogGroup"
        class="dialogGroup choose_device"
        :before-close="handleClose"
      >
        <v-choose
          :areaid="replaceid"
          :showcount="false"
          :searchtype="1"
          :isreplace="true"
          @confirm="confirm"
        />
      </el-dialog>
    </template>

    <template v-if="card_set">
      <el-dialog
        :title="
          model.ChildName != ''
            ? model.ChildName + '-' + model.DeviceName
            : model.DeviceName
        "
        :visible.sync="card_set"
        class="card_dialog"
        :modal-append-to-body="false"
      >
        <button
          class="button_E330 buttonRefresh"
          :class="!isDoCardsetResresh ? 'button_eventNone_E330' : ''"
          @click="cardsetResresh"
        >
          {{ $t("devicecard.refresh") }}↻
        </button>
        <div
          v-loading="$store.state.isloadingdetail"
          class="card_set"
        >
          <!-- <i @click="cardCloce" class="el-icon-close button_close"></i> -->
          <!-- <vuescroll> -->
          <el-scrollbar
            class="new_scrollbar"
            style="height: 100%"
          >
            <v-msg
              ref="cardsetObj"
              :devicemodel="model"
              @replacedevice="replacedevice"
              @removedevice="removedevice"
              @deletedevice="deletedevice"
              @dosuccess="dosuccess"
            />
            <!-- </vuescroll> -->
          </el-scrollbar>
        </div>
      </el-dialog>
    </template>

    <!-- <template v-if="courseDialog">
      <el-dialog
        :modal-append-to-body="false"
        class="cousreing"
        :visible.sync="courseDialog"
        width="650px"
        :before-close="handleCloseSynCurrent"
      >
        <v-course :removecurrent="removecurrent" @backgroundDoCurrent="backgroundDoCurrent">
					<span slot="cousreTitle">{{ cousreTitle }}</span>
				</v-course>
        <v-cds
          :removecurrent="removecurrent"
          :area-tree-type="1"
          :searchtype="1"
          @backgroundDo="backgroundDoCurrent"
        >
          <span slot="cousreTitle">{{ $t("courseDataySync.current") }}</span>
        </v-cds>
      </el-dialog>
    </template> -->

    <template v-if="is_removetree">
      <el-dialog
        :modal-append-to-body="false"
        class="remove_tree_cont"
        :visible.sync="is_removetree"
        width="650px"
        :before-close="handleClose"
      >
        <div class="remove_tree">
          <div class="blue_header">
            <span>{{ $t("install.remveblock") }}</span>
          </div>
          <i
            class="el-icon-close text-button"
            @click="close"
          />
          <radio-tree
            class="limit_set"
            @getareaid="getareaid"
          />
          <el-button
            class="limite_button"
            @click="finsh"
          >
            {{ $t("install.finsh") }}
          </el-button>
          <!-- <div class="limite_button" @click="finsh">{{ $t('install.finsh') }}</div> -->
        </div>
      </el-dialog>
    </template>
    <template v-if="imgDialog">
      <el-dialog
        :modal-append-to-body="false"
        :title="$t('devicecard.dowarn')"
        :visible.sync="imgDialog"
        class="imgDialog"
        width="30%"
        :before-close="handleClose"
      >
        <!-- style="margin-left: -15%;margin-top: -10%!important;min-width: 300px;" -->
        <img
          class="Dialogimg"
          :src="imgsrc"
        >
        <div class="Dialogimg">
          {{ imgsrcDesc }}
        </div>
      </el-dialog>
    </template>
  </div>
</template>

<script>
import {
  ChangeName,
  FindDevice,
  GetIdentifyInfo,
  PositiveIdentify,
  Replace,
} from "@/axios/IDevice.js";
import { alerterror, alertsuccess, warning } from "@/assets/js/common.js";
import {
  AddDevice,
  MoveDevice,
  ShowCurrentSyncResult,
  ReSyncAreaCode,
} from "@/axios/IArea.js";
import vuescroll from "vuescroll";
import vMsg from "./deviceMsg.vue";
import vCds from "./courseDataySync.vue";
import radioTree from "./radioTree.vue";
import vChoose from "./deviceChoose.vue";
import { catchRequireErr, getImgUrlState } from "@/utils/utils";
import Virtual_list from "./virtual_list_horizontal/index.vue";
import cardtwoSmallVirtual from "./cardtwoSmallVirtual.vue";
import { postWebIOSocket } from '@assets/socket';
export default {
  name: "Card",
  components: {
    vMsg,
    vuescroll,
    vCds,
    radioTree,
    vChoose: () => import('./deviceChoose.vue'),
    Virtual_list,
  },
  props: [
    "is_check",
    "cardlist",
    "isradio",
    "noclick",
    "isdel",
    "pageindex",
    "registerList",
    "isScrollRegist",
    'container-with-type',
    'wrap-width',
    'wrap-height',
    "requiredMaxDevice",
    "maxDevice",
    "hasSelectDevice"
  ],
  data() {
    return {
      isLoadingReplace: false,
      dialogGroup: false, //控制弹出层显示隐藏
      pmodel: null, //点击移动删除回传回来的对象
      cousreTitle: "XXXX",
      checkedGpno: -1, //移动区域的gpno
      removecurrent: [], //需要移动的设备集合
      is_removetree: false, //显示隐藏移动区域选择
      courseDialog: false, //显示隐藏同步看板
      isloading: false, //是否加载
      editorModel: null, //修改名字的对象
      card_set: false, //显示隐藏设备详情组件
      model: null, //点击选项卡的对象
      imgDialog: false, //识别弹窗
      imgsrc: "", //被动识别图片
      imgsrcDesc: "", //被动识别图片描述
      // carddata: [],
      replaceid: 0, //替换设备id
      registInfo: null, //注册参数-设备信息
      registIdentify: null, //注册参数-设备识别
      isDoCardsetResresh: true, //是否可执行刷新
      ardsetResreshTotalTime: 1000, //执行刷新间隔5秒
      getImgUrlState: getImgUrlState,
      // extraProps: {},
      cardtwoSmallVirtual,
    };
  }, //是否显示选择按钮 数据源 是否单选 是否不可点击 是否进行删除操作（控制回路不能删）
  computed: {
    socketmodel() {
      //比较函数 需要监听的数据
      return this.$store.state.socketmodel;
    },
    carddata() {
      //页面传递过来的数据
      // return this.registCard();
      if (this.cardlist == null || this.cardlist.length == 0) {
        // this.isScrollRegist = false;
      }
      console.log('...........页面传递过来的数据.', this.isScrollRegist)
      if (!this.isScrollRegist) {
        let array = [];
        array = this.registCard().filter(
          (msg) => !msg.isdisabled && msg.hidden != true
        );

        array.forEach((item) => {
          let ischecked = item.ischecked;
          delete item.ischecked;
          this.$set(item, "ischecked", ischecked);
        });
        
        return array.map(item => {
          return {
            ...item,
            isdisabled: item.isCheckBoxDisable
          }
        });
      } else {
        var temarry = [];
        this.cardlist.forEach((n) => {
          let ischecked = n.ischecked;
          delete n.ischecked;
          this.$set(n, "ischecked", ischecked);
          this.formatedevicestatus(n);
          if (!n.isdisabled && n.hidden != true) {
            temarry.push(n);
          }
        });
        return temarry;
      }
    },
    extraProps(){
      return{
        extraProps: {
        cardset: this.cardset,
        removeTree: this.removeTree,
        handleEnter: this.handleEnter,
        onStop: this.onStop,
        edit: this.edit,
        getParentAreaNames: this.getParentAreaNames,
        know: this.know,
        is_check:this.is_check,
        isradio:this.isradio,
        noclick:this.noclick
      },
      }
    }
  },
  watch: {
    socketmodel(rs) {
      //监听socket数据
      this.functionScoketsync_info_event(rs);
    },
    registerList(param) {
      //监听滚轴下滑传递过来的数据
      // if (this.registInfo != null) {
      // 	postWebIOSocket('sync_info_remove_event', this.registInfo);
      // }
      // if (this.registIdentify != null) {
      // 	postWebIOSocket('sync_info_remove_event', this.registIdentify);
      // }
      // this.registInfo = null;
      // this.registIdentify = null;
      // if (param != null && param.length > 0) {
      // 	this.registInfo = { data: [] };
      // 	this.registIdentify = { data: [] };
      // 	param.forEach(n => {
      // 		if (n.VDeviceId != null && n.ChildId != null) {
      // 			this.registInfo.data.push({ projectCode: this.$store.state.projectcode, type: 1, id: n.VDeviceId });
      // 			this.registIdentify.data.push({ projectCode: this.$store.state.projectcode, type: 3, id: n.Mac });
      // 		}
      // 	});
      // 	if (this.registInfo.data.length > 0) {
      // 		postWebIOSocket('sync_info_add_event', this.registInfo);
      // 	}
      // 	if (this.registIdentify.data.length > 0) {
      // 		postWebIOSocket('sync_info_add_event', this.registIdentify);
      // 	}
      // }
    },
  },
  destroyed() {
    //页面销毁 删掉socket信息
    //socket.close();
    //socket.emit('sync_info_removeall_event');
    if (this.registInfo != null) {
      postWebIOSocket("sync_info_remove_event", this.registInfo);
    }
    if (this.registIdentify != null) {
      postWebIOSocket("sync_info_remove_event", this.registIdentify);
    }
  },
  mounted() {
    this.getImgUrlState = getImgUrlState;
    this.isDoCardsetResresh = true;
    // 		this.carddata = this.cardlist;
    //
    // 		var _arr = [];
    // 		var para = { data: [] };
    // 		var paramac={data: []};
    // 		var _arrmac=[];
    // 		var temarry = [];
    // 		this.carddata.forEach(n => {
    // 			if (n.VDeviceId && n.ChildId) {
    // 				_arr.push({ projectCode: this.$store.state.projectcode, type: 1, id: n.VDeviceId });
    // 				_arrmac.push({ projectCode: this.$store.state.projectcode, type: 3, id: n.Mac });
    // 				this.formatedevicestatus(n);
    // 			}
    // 		});
    // 		para.data = _arr;
    // 		paramac.data=_arrmac;
    // 		if (para.data.length > 0) {
    // 			socket.emit('sync_info_add_event', para);
    // 			socket.emit('sync_info_add_event', paramac);
    // 		}
    // 		_arr = null;
    // 		para = null;
    // 		_arrmac=null;
    // 		paramac=null;
    //
    //socket.on('sync_info_event', this.functionScoketsync_info_event);
  },
  methods: {
    onStop() {},
    /**
     * 分解原始数据字段 doParentGpnos
     */
    doParentGpnos(device) {
      if (typeof device["ParentGpnos"] == "string") {
        //会归入父级所涉及区域
        var _ParentGpnos = device["ParentGpnos"];
        _ParentGpnos = _ParentGpnos && _ParentGpnos.replace(/@/g, "");
        _ParentGpnos = _ParentGpnos && _ParentGpnos.split(",");
        if (_ParentGpnos instanceof Array) {
          device["_ParentGpnos"] = _ParentGpnos.reverse();
        }
      }
    },
    getParentAreaNames(parentGpnos, item, tag) {
      if (parentGpnos != null && parentGpnos != "") {
        var _result = [],
          _item = parentGpnos.split(","),
          _param;
        if (_item != null) {
          _item.forEach((param) => {
            _param = param.replace(/@/g, "");

            // if(param.substring(0,1)=="@"){
            //   _param = param.substring(1,param.length);
            // }
            // if(_param.substr(_param.length-1,1)=="@"){
            //   _param = _param.substring(0,_param.length-1);
            // }
            _param = this.$store.state.areasGpName[_param];
            _param = _param && _param["GpName"];
            _result.push(_param);
          });
        }
        _item = null;
        _param = null;
        _result = _result.reverse().join(",");
        if (item[tag] == null) {
          item[tag] = _result;
        }
        return _result;
      }
    },
    /* 注册卡片socket信息 并且格式化card数据
     */
    registCard() {
      console.log('........注册卡片socket信息 并且格式化card数据', this.cardlist,this.$store.state.isregistersocket)
      if (this.$store.state.isregistersocket) {
        var _arr = [];
        var para = { data: [] };
        var paramac = { data: [] };
        var _arrmac = [];
        var temarry = [];
        var index = 0;
        var count = 0;
        if (this.pageindex) {
          count = (this.pageindex - 1) * 30;
        }
        this.cardlist.forEach((n) => {
          if (index >= count) {
            if (n.VDeviceId != null && n.ChildId != null) {
              _arr.push({
                projectCode: this.$store.state.projectcode,
                type: 1,
                id: n.VDeviceId,
              });
              _arrmac.push({
                projectCode: this.$store.state.projectcode,
                type: 3,
                id: n.Mac,
              });
              this.formatedevicestatus(n);
            }
          }
          temarry.push(n);
          index++;
        });

        para.data = _arr;
        paramac.data = _arrmac;
        if (para.data.length > 0) {
          postWebIOSocket("sync_info_add_event", para);
          postWebIOSocket("sync_info_add_event", paramac);
          this.$store.dispatch("changeIsregisterSocket", false);
        }
        _arr = null;
        para = null;
        _arrmac = null;
        paramac = null;
        count = null;
        index = null;
        // console.log(temarry);
        return temarry;
      } else {
        //deepwatch  return this.cardlist；
        var temarry = [];
        this.cardlist.forEach((n) => {
          this.formatedevicestatus(n);
          temarry.push(n);
        });
        return temarry;
      }
    },
    /* 格式化mac显示
     */
    /* 格式化mac显示
     * val：原始的mac值
     */
    macformate(val) {
      return formateMac(val);
    },
    /* 点击确认替换执行的方法
     * list：需要替换的设备数组
     */
    confirm(list) {
      if (this.isLoadingReplace) return;

      this.isLoadingReplace = true;

      var para = {
        vDeviceId: this.replaceid,
        otherVDeviceId: list[0].VDeviceId,
      };
      Replace(para, this.functionDoReplace);
      para = null;
    },
    /* 替换接口返回的数据处理
     * rs：返回的原始数据包
     */
    functionDoReplace(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode);
        this.$emit("dosuccess", 2);
      } else {
        alerterror(this, rs.StatusCode);
      }
      this.isLoadingReplace = false;
      this.dialogGroup = false;
    },
    /* 点击替换显示弹出窗
     * item：当前的设备对象
     * */
    replacedevice(item) {
      this.replaceid = parseInt(item.VDeviceId);
      this.dialogGroup = true;
    },
    /* 获得移动的区域gpno
     * val：gpno值
     */
    getareaid(val) {
      //获得移动区域gpno
      this.checkedGpno = val;
    },
    /* 执行移动操作接口返回数据处理 不需要对接口数据做任何处理 直接弹出同步看板 同时关闭区域选择弹窗
     * rs：接口返回原始数据包
     * */
    functionDoNotice(rs) {
      //去掉同步看板
      // this.courseDialog = true;
      this.handleCloseSynCurrent()
      this.is_removetree = false;
    },
    /* 将选中的设备移动到指定区域 如果设备在无区域使用/api/Area/AddDevice 反之/api/Area/MoveDevice
     */
    doremove() {
      this.removecurrent = [];
      var para = {};
      this.removecurrent.push({
        GpNo: this.checkedGpno,
        VDeviceId: this.pmodel.VDeviceId,
        ChannelId: this.pmodel.ChildId,
      });
      if (this.pmodel.Gpno == 0) {
        para.GpNo = this.checkedGpno;
        para.VDeviceId = this.pmodel.VDeviceId;
        para.ChannelId = this.pmodel.ChildId;
        AddDevice(para, this.functionDoNotice);
      } else if (this.checkedGpno != this.pmodel.Gpno) {
          para.srcGpNo = this.pmodel.Gpno;
          para.destGpNo = this.checkedGpno;
          para.vDeviceId = this.pmodel.VDeviceId;
          para.channelId = this.pmodel.ChildId;
          MoveDevice(para, this.functionDoNotice);
        } else {
          warning(this, this.$t("devicelist.warnmove"));
        }
      para = null;
    },
    /* 点击执行移动操作
     */
    finsh() {
      if (this.checkedGpno != -1) {
        // this.is_removetree = false;
        // this.courseing = true;
        this.doremove();
      } else {
        warning(this, this.$t("install.areacounterror"));
      }
    },
    /* 关闭移动弹窗
     */
    close() {
      this.is_removetree = false;
    },
    /* 关闭同步组件 向调用的窗体传返回值
     * done：组件自带属性 关闭弹窗
     */
    handleCloseSynCurrent(done) {
      done &&  done();
      this.model = null;
      this.card_set = false;
      this.$emit("dosuccess", 2);
    },
    /* 关闭弹窗公用方法
     * done：组件自带属性 关闭弹窗
     */
    handleClose(done) {
      done();
      this.imgsrc = "";
      this.imgsrcDesc = "";
    },
    /* 点击后台执行 通知调用组件
     */
    backgroundDoCurrent() {
      this.courseDialog = false;
      this.model = null;
      this.card_set = false;
      this.$emit("dosuccess", 2);
    },
    /* 点击弹出移动设备的区域树
     */
    removedevice(item) {
      this.pmodel = item;
      this.is_removetree = true;
    },
    /* 点击弹出删除设备确认 并对参数赋值
     */
    deletedevice(item) {
      this.pmodel = item;
      this.removecurrent.push({
        GpNo: this.pmodel.Gpno,
        VDeviceId: this.pmodel.VDeviceId,
        ChannelId: this.pmodel.ChildId,
      });
      // 去掉同步看板
      // this.courseDialog = true;
      this.handleCloseSynCurrent()
    },
    /* 识别设备处理方法
     * rs：接口返回的原始数据包
     * para：向接口传递的参数
     * model：当前识别的设备对象
     */
    functionDoPositiveIdentify(rs, para, model) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        model.isflicker = true;
        setTimeout(() => {
          model.isflicker = false;
        }, 2000);
      } else {
        alerterror(this, rs.StatusCode);
      }
    },
    /* socket推送处理方法
     * rs：推送过来的原始数据包
     */
    functionScoketsync_info_event(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        if (rs.Result[0].Type == 3) {
          //被动识别
          this.imgDialog = false;
          this.carddata.forEach((n) => {
            if (n.Mac == rs.Result[0].DeviceMac) {
              n.isflicker = true;
              //socket.emit('sync_info_remove_event', { data: [{ projectCode: this.$store.state.projectcode, type: 3, id: n.Mac }] });
              setTimeout(() => {
                n.isflicker = false;
              }, 2000);
            }
          });
        } else if (rs.Result[0].Type == 15) {
          //修改名称d

          this.carddata.forEach((n) => {
            if (
              n.VDeviceId == rs.Result[0].Id &&
              n.ChildId == rs.Result[0].ChannelId
            ) {
              if (n.ChildId == 65535) {
                n.DeviceName = rs.Result[0].SyncInfo;
              } else {
                n.ChildName = rs.Result[0].SyncInfo;
              }
            }
          });
        } else if (rs.Result[0].Type == 11) {
          this.carddata.forEach((h) => {
            if (h.VDeviceId == rs.Result[0].VDeviceId) {
              rs.Result[0].StatusInfo.forEach((n) => {
                if (h.StatusInfo) {
                  h.StatusInfo.forEach((m) => {
                    // if (m.StatusCode == n.StatusCode) {
                    // 	m.Value = n.Value;
                    // }
                    // if (m.StatusCode == '0x0000') {
                    // 	h.IsOnline = n.Value == '0x0000' ? true : false;
                    // }
                    if (
                      m.StatusType == n.StatusType &&
                      m.ChannelId == n.ChannelId
                    ) {
                      m.Value = n.Value;
                    }
                    if (m.StatusCode == "0x0100") {
                      h.IsOnline = n.Value == "1";
                    }
                  });
                }
              });
              this.formatedevicestatus(h);
            }
          });
        } else if (rs.Result[0].Type == 10) {
          //在线状态
          this.carddata.forEach((n) => {
            if (n.VDeviceId == rs.Result[0].VDeviceId) {
              n.IsOnline = rs.Result[0].IsOnline;
            }
          });
        } else if (rs.Result[0].Type == 13) {
          //移动状态（同步中）

          this.carddata.forEach((n) => {
            if (n.VDeviceId == rs.Result[0].VDeviceId) {
              n.InAreaResultCode = rs.Result[0].InAreaResultCode;
            }
          });
        }
      }
    },
    /* 格式化设备数据
     * item：设备对象
     */
    formatedevicestatus(item) {
      //格式化设备状态
      if (item.StatusInfo) {
        if (item.StatusInfo != null && item.StatusInfo != "") {
          var isReturn = false;
          item.StatusInfo.forEach((n) => {
            if (n.StatusType == "0x0600") {
              this.getilluminationValue(n);
            } else if (n.StatusType == "0x0700") {
              this.gettemperatureValue(n);
            } else if (n.StatusType == "0x1600" || n.StatusType == "0x1601") {
              //上电时长/开灯时长 界面将秒转成小时
              this.getpowertimeValue(n);
            }
            isReturn = false;
            this.$store.state.deiveStatus.forEach((m) => {
              if (m.Key == n.StatusType) {
                //校准匹配 isReturn = true;
                m.Value.forEach((t) => {
                  if (t.Value != undefined) {
                    if (t.Value == n.Value) {
                      n.Value1 = n.Value;
                      n.Value = t.Key;
                      n.ParaUnit = "";
                      isReturn = true;
                    }
                  } else {
                    //console.log(n.Name+":"+n.Value);
                  }
                  // else {
                  // 	var _value = Number(n.Value);
                  // 	if (_value >= t.Min && _value < t.Max) {
                  // 		n.Value = t.Key;
                  // 		n.ParaUnit="";
                  //
                  // 	}
                  // }
                });
              }
            });
            if (isReturn == true) {
              return;
            }

            this.$store.state.deiveStatus.forEach((m) => {
              if (m.Key == n.StatusType.substring(0, 4)) {
                //匹配大类
                m.Value.forEach((t) => {
                  if (t.Value != undefined) {
                    if (t.Value == n.Value) {
                      n.Value1 = n.Value;
                      n.Value = t.Key;
                      n.ParaUnit = "";
                    }
                  } else {
                    //console.log(n.Name+":"+n.Value);
                  }
                  // else {
                  // 	var _value = Number(n.Value);
                  // 	if (_value >= t.Min && _value < t.Max) {
                  // 		n.Value = t.Key;
                  // 		n.ParaUnit="";
                  //
                  // 	}
                  // }
                });
              }
            });
          });
        }
      }
    },
    /* 注册socket
     * model：设备对象
     */
    dosocket(model) {
      var para = {
        data: [
          {
            projectCode: this.$store.state.projectcode,
            type: 3,
            id: model.Mac,
          },
        ],
      };
      postWebIOSocket("sync_info_add_event", para);
      para = null;
    },
    /* 去识别设备
     * result：接口原始数据包
     * model：设备对象
     */
    doPositiveIdentify(result, model) {
      if (result.IdentifyType == 1 || result.IdentifyType == 2) {
        //被动识别
        this.dosocket(model);
        var _imgurl = "";
        if (model.ClassSku == "0x02000308") {
          _imgurl = require("@static/device/identify/nonev2.png");
        } else if (
          result.IntroImage == "" ||
          result.IntroImage == null ||
          result.IntroImage.indexOf("http") != -1
        ) {
          _imgurl = require("@static/device/identify/none.png");
        } else {
          _imgurl = catchRequireErr(() => require("@static/device/identify/" + result.IntroImage));
        }
        this.imgsrc = _imgurl;
        this.imgsrcDesc = result["IntroDesc"] || "";
        this.imgDialog = true;
        _imgurl = null;
      } else {
        var para = {
          mac: model.Mac,
          deviceId: model.VDeviceId,
          channelId: model.ChildId,
        };
        PositiveIdentify(para, this.functionDoPositiveIdentify, model);
        para = null;
      }
    },
    /* 获得设备的识别方式接口返回数据处理
     * rs：接口原始数据包
     * para：传递的参数
     * model：设备对象
     */
    functionDoGetIdentifyInfo(rs, para, model) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        //去识别

        this.doPositiveIdentify(rs.Result, model);
      } else {
        alerterror(this, rs.StatusCode);
      }
    },
    /* 查询设备认领方式
     * model：设备对象
     */
    doGetIdentifyInfo(model) {
      //查询设备认领方式
      var para = { classSku: model.ClassSku, channelId: model.ChannelId };
      GetIdentifyInfo(para, this.functionDoGetIdentifyInfo, model);
      para = null;
    },
    /* 页面点击识别执行的方法
     * model：设备对象
     */
    know(model) {
      this.doGetIdentifyInfo(model);
      // model.isflicker = true;
      // setTimeout(()=>{
      // 	model.isflicker = false;
      // },2000);
      // this.imgDialog = true;
    },
    /* 修改设备名称接口返回数据处理
     * rs：接口原始数据包
     */
    functionDoChangeName(rs) {
      console.log(rs);
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode);
        this.triggerSocketName();
      } else {
        alerterror(this, rs.StatusCode);
      }
    },
    /* 修改完设备名称以后 通知socket广播
     */
    triggerSocketName() {
      var para = {
        data: [
          {
            projectCode: this.$store.state.projectcode,
            type: 15,
            id: this.editorModel.VDeviceId,
            channelId: this.editorModel.ChildId,
            syncInfo:
              this.editorModel.ChildId == 65535
                ? this.editorModel.DeviceName
                : this.editorModel.ChildName,
          },
        ],
      };
      console.log(para);
      postWebIOSocket("sync_info_trigger_event", para);
      para = null;
    },
    /* 执行修改设备名称动作
     */
    doChangeName() {
      var para = {
        vDeviceId: this.editorModel.VDeviceId,
        channelId: this.editorModel.ChildId,
        newName:
          this.editorModel.ChildId == 65535
            ? this.editorModel.DeviceName
            : this.editorModel.ChildName,
        location: 0,
      };
      ChangeName(para, this.functionDoChangeName);
      para = null;
    },
    /* 按回车执行修改名称
     * msg:设备对象
     */
    handleEnter(msg) {
      this.editorName(msg);
    },
    /* 点击执行修改名称
     * msg:设备对象
     */
    edit(msg) {
      this.editorName(msg);
    },
    /* 点击执行修改名称
     * msg:设备对象
     */
    editorName(msg) {
      msg.flag = !msg.flag;
      if (!msg.flag) {
        this.editorModel = msg;
        this.doChangeName();
      }
    },
    /* 关闭设备详情
     */
    cardCloce() {
      this.model = null;
      this.card_set = false;
    },
    /* 点击弹窗设备详情
     */
    cardset(val) {
      if (this.is_check) {
        //点击选中选项卡
        this.cliclChoose(val);
        this.$emit("removeTree", [this.carddata, val]);
      } else if (!this.noclick) {
          this.model = val;
          this.card_set = true;
          //this.doFindDevice(val.VDeviceId,val.ChildId);
        }
    },
    /* 设备详情接口返回数据处理
     * rs:接口返回原始数据包
     */
    functionDoFindDevice(rs) {
      this.isloading = false;
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        this.model = rs.Result;
        this.card_set = true;
      }
    },
    /* 去查找设备详情
     * vid:vDeviceId 设备虚拟id
     * cid:channelId 回路号
     */
    doFindDevice(vid, cid) {
      //获得设备详情
      this.isloading = true;
      var para = { vDeviceId: vid, channelId: cid };
      FindDevice(para, this.functionDoFindDevice);
      para = null;
    },
    /* 点击设备卡选择谁被 区分单选多选
     * val:设备对象
     */
    doclickchoose(val) {
      if (this.isradio) {
        if (!val.ischecked) {
          val.ischecked = !val.ischecked;
        }
      } else if (!val.isdisabled) {


        //天幕选择设备只能单选编辑，因为每个天幕的场景不同
        const TianMuCardList = this.carddata.filter(item=> item.ischecked && item.ClassSku === '0x50070001')
        
        if(TianMuCardList.length >=1){
          if(TianMuCardList[0].VDeviceId === val.VDeviceId){
            val.ischecked = false
            return
          }

          warning(this, this.$t('tianmu.onlyOneTime'))

          return
        }


          if(this.requiredMaxDevice  && !val.ischecked){
            console.log('.......this.hasSelectDevice',this.hasSelectDevice)
            if(this.carddata.filter(item => item.ischecked).length < (this.maxDevice-this.hasSelectDevice)){
              val.ischecked = !val.ischecked;
            }else{
              warning(this, this.$t('adddevice.addMaxDeviceTitle').replace('{{max}}', this.maxDevice));
            }
          }else{
            val.ischecked = !val.ischecked;
          }
         
        }
    },
    /* 点击设备卡选择谁被 区分单选多选 如果是删除模式下 需要判断是不是回路 回路不可被删除
     * val:设备对象
     */
    cliclChoose(val) {
      if (this.isdel) {
        if (val.ChildId == 65535) {
          this.doclickchoose(val);
        } else {
          warning(this, this.$t("devicecard.delDeviceInfo"));
        }
      } else {
        this.doclickchoose(val);
      }
    },
    /* 通知调用组件
     * val:传递的值
     */
    removeTree(val) {
      
      this.cliclChoose(val);
      this.$emit("removeTree", [this.carddata, val]);
    },
    /* 通知调用组件
     * val:传递的值
     */
    dosuccess(val) {
      this.model = null;
      this.card_set = false;
      this.$emit("dosuccess", val);
    },
    cardsetResresh() {
      if (!this.isDoCardsetResresh) {
        return;
      }
      this.isDoCardsetResresh = false;
      let ardsetResreshTotalClock = window.setInterval(() => {
        this.ardsetResreshTotalTime--;
        if (this.ardsetResreshTotalTime < 0) {
          window.clearInterval(ardsetResreshTotalClock);
          this.ardsetResreshTotalTime = 1000;
          this.isDoCardsetResresh = true;
        }
      });
      var dd = this.$refs.cardsetObj.mountedDo;
      if (typeof dd == "function") {
        dd(true);
      }
      dd = null;
    },
  },
};
</script>

<style lang="scss" scoped>
/* 设备卡片样式	 */
// .card_list:hover{
//   border: solid 1px #dde8f7;
//   border-radius: 20px;
// }
.card_mian {
  height: 100%;
}
.list {
  height: 100%;
}
.card_dialog {
  .buttonRefresh {
    right: 60px;
    position: absolute;
    top: 18px;
    padding: 3px 8px;
  }
}

.content .imgDialog .dialogGroup .el-dialog {
  margin: -15% !important;
}
</style>
